export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/403w-e1bd4a32a4e747e60ec5da29c9796952.webp";